import { createAction } from '@ngrx/store';
import { DotCMSConfigurationParams } from 'dotcms/src/lib/models';
import { DotCMSLanguageItem } from 'dotcms/src/lib/models/DotCMSLanguage.model';

import { httpError, payload } from 'ish-core/utils/ngrx-creators';

export const loadDotCmsConfiguration = createAction('[DOTCMS Configuration Internal] Load dotCMS Configuration');

export const loadDotCmsConfigurationSuccess = createAction(
  '[DOTCMS Configuration API] Load dotCMS Configuration Success',
  payload<{ apiConfiguration: DotCMSConfigurationParams }>()
);

export const loadDotCmsConfigurationFail = createAction(
  '[DOTCMS Configuration API] Load dotCMS Configuration Fail',
  httpError()
);

export const getDotCmsSiteConfiguration = createAction('[DOTCMS Configuration Internal] Get dotCMS Site Configuration');

export const getDotCmsSiteConfigurationFail = createAction(
  '[DOTCMS Configuration Internal] Get dotCMS Site Configuration Fail',
  httpError()
);

export const loadDotCmsAvailableLanguages = createAction('[DOTCMS Configuration Internal] Load Available Languages');

export const loadDotCmsAvailableLanguagesSuccess = createAction(
  '[DOTCMS Configuration API] Load Available Languages Success',
  payload<{ languages: DotCMSLanguageItem[] }>()
);

export const loadDotCmsAvailableLanguagesFail = createAction(
  '[DOTCMS Configuration API] Load Available Languages Fail',
  httpError()
);

export const setDotCmsSelectedLanguage = createAction(
  '[DOTCMS Configuration Internal] Set Selected Language',
  payload<{ language: DotCMSLanguageItem }>()
);

export const setDotCmsPersona = createAction(
  '[DOTCMS Configuration Internal] Set Dot Cms Persona',
  payload<{ personaId?: string }>()
);

export const updateDotCmsPersona = createAction('[DOTCMS Configuration Internal] Update Dot Cms Persona');

export const setDotCmsApiCallRestrictionStatus = createAction(
  '[DOTCMS Configuration Internal] set DotCms Api Call restriction'
);

export const allowDotCmsApiCall = createAction('[DOTCMS Configuration Internal] Allow DotCms api call');

export const restrictDotCmsApiCall = createAction('[DOTCMS Configuration Internal] Restrict DotCms api call');

export const setDotCmsLanguagePreference = createAction(
  '[DOTCMS Configuration Internal] Set dotCMS Language Preference',
  payload<{ language: number }>()
);
